import React from 'react';
import * as styles from './index.module.scss';

export const FooterSocials = ({ data }) => {
  return (
    <section className={styles.socialsColumn}>
      <p className={styles.listTitle}>Social Links</p>
      <ul className={styles.socialsList}>
        {data && data.map((social, index) => (
          <li key={`footer-socials-${index}`}>
            <a
              href={social.url || '#'}
              alt={social.title}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={social.image.url}
                alt={`${social?.title}`}
              />
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};
